import { jQuery } from './utils/jquery.js';

jQuery(function ($) {
    var productGiftCardInstance = {
        // bind_actual_plugin_mail_to_input: Bind custom attribute input into original plugin input value
        bind_actual_plugin_from_input: function (val) {
            $('#pwgc-from').val(val);
        },
        bind_actual_plugin_msg_input: function (val) {
            $('#pwgc-message').val(val);
        },
        bind_actual_plugin_mail_to_input: function (val) {
            $('#pwgc-to').val(val);
        },
        bind_actual_plugin_custom_amount_input: function (val) {
            $('#pwgc-custom-amount').val(val);
        },
        is_gift_card_product: function () {
            if ($(document).find('.product-type-pw-gift-card').length) {
                return true;
            } else {
                return false;
            }
        }
    }
    // event on gift amount button
    $(document).on('click', '.js-product-gift-card-option', function () {
        // check is this a gift card product
        if (!productGiftCardInstance.is_gift_card_product()) {
            return;
        }
        let giftSelectElId = $(this).data('select-id');
        let giftSelectEl = $('#' + giftSelectElId);
        let optionVal = $(this).data('value');
        giftSelectEl.val(optionVal).trigger('change');

        if (optionVal == 'Autre montant') {
            $('.js-gift-custom').focus();
            $('.js-gift-custom').val('');
            $('.gift-other-amount').show();
        } else {
            $('.gift-other-amount').hide();
        }
    });

    $(document).on('change keyup', '.js-gift-custom', function () {
        productGiftCardInstance.bind_actual_plugin_custom_amount_input($(this).val());
    });

    //Event on  js-gift-to
    $(document).on('change keyup', '.js-gift-to', function () {
        productGiftCardInstance.bind_actual_plugin_mail_to_input($(this).val());
    });
    // Event on js-gift-from
    $(document).on('change keyup', '.js-gift-from', function () {
        productGiftCardInstance.bind_actual_plugin_from_input($(this).val());
    });

    $(document).on('validate_add_to_cart', function () {
        // check is this a gift card product
        if (!productGiftCardInstance.is_gift_card_product()) {
            return true;
        }
        // do validate all custom gift inputs
        let customGiftInputsClasses = ['js-gift-to', 'js-gift-from'];
        let gotErrorInCustomGiftCardForm = false;
        $(customGiftInputsClasses).each(function (eachIndex, eachEl) {
            let inputEl = $('.' + eachEl);
            let inputVal = inputEl.val();
            if (typeof inputVal === "undefined" || !inputVal) {
                gotErrorInCustomGiftCardForm = true;
                $('.' + eachEl).get(0).setCustomValidity('Ce champ est nécessaire');
                $('.' + eachEl).get(0).reportValidity();
            }
        });


        // let continue the trigger process
        // if we found error
        if (gotErrorInCustomGiftCardForm) {
            // prevent form submitting
            return false;
        } else {
            // let continue trigger handling
            return true;
        }
    });

    // Event bind on update custom message
});
